// This file was auto-generated by Fern from our API Definition.
export var WorkflowRevisionOperation;
(function (WorkflowRevisionOperation) {
    WorkflowRevisionOperation.Operation = {
        Set: "set",
        Merge: "merge",
        Remove: "remove",
        EditText: "edit_text",
        AddItem: "add_item",
        ReplaceItem: "replace_item",
        RemoveItem: "remove_item",
    };
    WorkflowRevisionOperation.MatchMode = {
        Auto: "auto",
        Exact: "exact",
    };
})(WorkflowRevisionOperation || (WorkflowRevisionOperation = {}));
